import React from "react";
import { useTranslation } from "react-i18next";

export const HG404 = () => {
    const {t} = useTranslation()
    return(
        <>
        <div className="contentBox">
            <div className="tabBox">
                <div className="left">
                    <h3>
                        <span>HYUNDAI ENGINE:</span>
                        HG404TA2
                    </h3>
                    <ul className="tabBtnBox">
                        <li className="active">{t("hyundai_8")}</li>
                        <li>{t("hyundai_9")}</li>
                    </ul>
                    {/* <!-- 탭 버튼 : 클릭시 active클래스 --> */}
                </div>
                <div className="right">
                    <div className="tabContentBox">
                        <div className="imgBox active">
                            <img src="/assets/images/hg404_view_img.png" alt="HG404TA2"/>
                        </div>
                        <div className="imgBox">
                            <img src="/assets/images/hg404_view_drawing.png" alt="HG404TA2"/>
                        </div>
                    </div>
                    {/* <!-- 탭버튼에 따라 이미지 변경 --> */}
                </div>
            </div>

            <div className="tableWrap generator">
                <table>
                    <thead>
                        <tr>
                            <th>{t("hyundai_40")}</th>
                            <th colSpan={4}>{t("hyundai_41")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowSpan={18}>{t("hyundai_42")}</td>
                            <td colSpan={2} className="width_220">{t("hyundai_43")}</td>
                            <td className="width_140">{t("hyundai_44")}</td>
                            <td>HG404TA2</td>
                        </tr>
                        <tr>
                            <td rowSpan={2} className="width_105">{t("hyundai_45")}</td>
                            <td className="width_115">60Hz</td>
                            <td>PS/RPM</td>
                            <td>170/1800</td>
                        </tr>
                        <tr>
                            <td className="width_115">50Hz</td>
                            <td>PS/RPM</td>
                            <td>125/1500</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_46")}</td>
                            <td></td>
                            <td>4</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_47")}</td>
                            <td>mm</td>
                            <td>103x118</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_48")}</td>
                            <td>cc</td>
                            <td>3,933</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_49")}</td>
                            <td></td>
                            <td>{t("hyundai_50_2")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_51")}</td>
                            <td>ℓ/hr</td>
                            <td>22.5</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_52")}</td>
                            <td></td>
                            <td>TCI</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_53")}</td>
                            <td></td>
                            <td>{t("hyundai_54")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_55")}</td>
                            <td>ℓ</td>
                            <td>15</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_56")}</td>
                            <td></td>
                            <td>{t("hyundai_57")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_58")}</td>
                            <td></td>
                            <td>{t("hyundai_59")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_60")}</td>
                            <td></td>
                            <td>{t("hyundai_61")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_62")}</td>
                            <td>V-KW</td>
                            <td>24-5</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_63")}</td>
                            <td>V-A</td>
                            <td>24-70</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_64")}</td>
                            <td>mm</td>
                            <td>1,623×760＋1,017</td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="width_220">{t("hyundai_64_2")}</td>
                            <td>kg</td>
                            <td>380</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td rowSpan={8}>{t("hyundai_65")}</td>
                            <td rowSpan={2} className="width_105">{t("hyundai_66")}</td>
                            <td className="width_115">60Hz</td>
                            <td>KVA/kW</td>
                            <td>125/100</td>
                        </tr>
                        <tr>
                            <td className="width_115">50Hz</td>
                            <td>KVA/kW</td>
                            <td>88/70</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>{t("hyundai_67")}</td>
                            <td></td>
                            <td>220VAC/380VAC/445VAC</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>{t("hyundai_68")}</td>
                            <td></td>
                            <td>{t("hyundai_69")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>{t("hyundai_70")}</td>
                            <td></td>
                            <td>{t("hyundai_71")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>{t("hyundai_72")}</td>
                            <td></td>
                            <td>85.7%{t("hyundai_73")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>{t("hyundai_74")}</td>
                            <td></td>
                            <td>{t("hyundai_75")}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>{t("hyundai_76")}</td>
                            <td></td>
                            <td>IP23</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </>
    )
}